<template>
    <div :ref=id :style="{ height: height, width: width }" />
</template>
<script>

import * as echarts from 'echarts'

export default {
  name: 'ChartView',
  props: {
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    chartOption: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartOption: {
      deep: true,
      handler(newVal) {
        this.setOptions(newVal);
      }
    }
  },
  mounted() {
    if (!this.myChart) {
      this.initChart(this.id);
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.resizeHandler)
    if (this.myChart) this.myChart.dispose()
    this.chart = null
  },
  methods: {
    initChart(chartId) {
      this.chart = echarts.init(this.$refs[chartId])
      this.setOptions(this.chartOption);
    },
    setOptions(option) {
      if (this.chart) {
        this.chart.setOption(option)
        this.resizeHandler()
      }
    },
    resizeHandler() {
      this.chart.resize()
    },
  }
}
</script>